// 手机验证
<template>
<div>
  <div class="g-bd">
    <div class="m-tlt">登录前请先验证安全手机：<span>{{mb}}</span></div>
     <Form class="m-form" ref="form">
      <form-item class='m-ipt ipt-h' ref="smsValidate">
      <urs-input placeholder="请输入短信验证码" ref='smsInput'
      size="small" :validate="validateSms" ><urs-button class='u-btn-sms' ref=smsBtn enableTip="获取验证码"
      :count="smsCount"
      slot="button" @click="onGetSms" ></urs-button></urs-input>
      </form-item>
      <div v-if="showUp!==''" class="m-tlt del-bottom c-main" v-html="showUp"></div>
      <div class="m-btns g-pd">
        <urs-button enableTip="确定" @click="onSubmit" ref="submitBtn"></urs-button>
      </div>
     </Form>
  </div>
  <div class="g-ft g-pd clearfix c-main">
    <a class="f-right" href="https://gj.reg.163.com/faq/p4.html?ct=05">安全手机无法使用？</a>
  </div>
</div>
</template>

<script>
import reqProxy from '../util/request'
import util from '../util/util'
import code from '../util/codemapper'

// @NOTE 两个接口返回码文案基本一致，合并一个
let vfsmsCode = {
  '431': "请求错误，请您稍后再试",
  '410': "超过IP限制，请稍候再试",
  '412': "验证码错误次数过多，请明天再试",
  '413': "当日尝试次数过多，请明天再试",
  '443':"请输入正确的短信验证码",
  '453': "账号未关联手机号",
  '454': "账号关联手机未验证",
  '430': "此次登录不需要进行密保验证",
  '506': "短信发送失败，请稍后再试",
  '458': "短信发送过于频繁，请稍后再试"
  }

util.merge(vfsmsCode, code);

export default {
  props: {
    options:Object
  },
  data () {
    let _this=this;
    return {
      mb: this.options.mb,
      smsCount: 29,
      showUp: '',
      validateSms () {
        let val = this.currentValue;
        let _regexp = /^[0-9]{6}$/;
        if(val === ''||!_regexp.test(val)){
           _this.$refs.smsValidate.setMsg('请输入正确的验证码');
          return false;
        }
        return true
      }
    }
  },
  mounted () {
    window.Loading.loading = false;
    if (this.options.errMsg){
      window.showError(this.options.errMsg)
    }
  },
  methods: {
    // 点击确认提交
    onSubmit () {
      // 表单校验
      if(this.$refs.smsInput.validate())
      {
        this.$refs.submitBtn.state = 'loading';
        // 提交安全手机验证
        let data = {
          un: this.options.un,
          mb: this.mb,
          sms: this.$refs.smsInput.currentValue,
        }
        if (this.newUp){
          data.n = 1;
        }
        reqProxy({
          url: '/vfsms',
          method: 'POST',
          contentType: 'application/x-www-form-urlencoded',
          data: data,
          success: (data)=>{
            // 校验成功
            // 回到登录且自动帮助用户登录
            this.$refs.submitBtn.state = 'enable'
            this.$emit('changeToLogin',{autoLogin:1})
          },
          error:(data)=>{
            this.$refs.submitBtn.state = 'enable'
            // 特殊错误-返回登录界面
            if(data.ret == '430' || data.ret === '434' ||data.ret === '435' || data.ret === '436' || data.ret === '437' || data.ret === '413' || data.ret === '412'){
              this.$emit('changeToLogin',{errMsg:vfsmsCode[data.ret]})
              return;
            }
            if(data.ret==='401'&&data.dt==='10'){
              data.ret='40110'
               this.$emit('changeToLogin',{errMsg:vfsmsCode[data.ret]})
              return;
            }
            // 通用错误
            window.showError(vfsmsCode[data.ret]);

          }
        })
      }

    },
    // 点击获取短信验证码
    onGetSms () {
      let data = {
        un: this.options.un
      }
      this.$refs.smsBtn.state = 'disable';
      reqProxy({
        url: '/sm',
        method: 'GET',
        data: data,
        success:(data)=>{
          // 成功获取短信验证码
          this.$refs.smsBtn.state = 'enable';
          this.$refs.smsBtn.countDown();
          // 清除上行标记
          this.showUp = '';
          if (data.dt === '02'){
            this.newUp = true;
          }
        },
        error:(data)=>{
          this.$refs.smsBtn.state = 'enable';
          // 上行
          if(data.ret=='411'){
            let dt = data.dt;
            if (dt === '02'){
              this.newUp = true;
              this.$emit('changeModule',{module:'smsup',mobile:this.mb,receiveCode:data.receiveCode})
              // 新版上行
            }else{
              this.showUp = '请用以上手机编辑短信 <strong>'+(data.receiveCode.split(',')[0]||'验证')+'</strong> 发送到 <strong>'+(data.receiveCode.split(',')[1]||'1069 8163 0163 331')+'</strong> 之后将获取到的验证码填入验证码输入框';
            }
            return;
          }
          // 特殊错误-返回登录界面
          if(data.ret == '430' || data.ret === '434' ||data.ret === '435' || data.ret === '436' || data.ret === '437' || data.ret === '413' || data.ret === '412'){
            this.$emit('changeToLogin',{errMsg:vfsmsCode[data.ret]})
              return;
          }
          // 通用错误
          window.showError(vfsmsCode[data.ret]);
        }
      })
    },
  }
}
</script>





// WEBPACK FOOTER //
// Verifymb.vue?1fab4274